module.exports = __webpack_public_path__ + "images/emoji/clubs.94b21b42081df1efd6c7.png";